import React from 'react';
import ForgetPasswordForm from './ForgetPasswordForm';

const ForgetPassword = () => 
<div className="text-center">
  <h5 className="mb-0"> ¿Olvidaste tu contraseña?</h5>
  <small>Ingrese su correo electrónico y le enviaremos un enlace de restablecimiento.</small>
  <ForgetPasswordForm />
</div>

export default ForgetPassword;